const SCRIPT_ID = "recaptcha-enterprise-script";
const BADGE_VISIBLE_CLASS = "recaptcha-badge-visible";

let activeViews = 0;

export function showRecaptchaBadge(siteKey) {
	activeViews++;
	if (!siteKey) {
		return;
	}
	if (!document.getElementById(SCRIPT_ID)) {
		let recaptchaScript = document.createElement("script");
		recaptchaScript.setAttribute("id", SCRIPT_ID);
		recaptchaScript.setAttribute("src", `https://www.google.com/recaptcha/enterprise.js?render=${siteKey}`);
		document.head.appendChild(recaptchaScript);
	}
	document.body.classList.add(BADGE_VISIBLE_CLASS);
}

export function hideRecaptchaBadge() {
	activeViews = Math.max(0, activeViews - 1);
	if (activeViews === 0) {
		document.body.classList.remove(BADGE_VISIBLE_CLASS);
	}
}
